import {FrontWebSongModel, FrontWebSongRadioModel} from "../../../generated";
import SongCss from "../Style.module.scss";
import { LogoBox } from "../Image/LogoBox";
import React, {useState} from "react";
import routes from "../../../utils/routes";
import { RouteLink } from "../../RouteLink";
import { usePlayOrStop } from "../../Player";

export const SongBox = (props: {
    song: FrontWebSongRadioModel|FrontWebSongModel,
    className?: string
}) => {
    const {
        interpret,
        song,
        image,
    } = props.song;

    const radio = "radio" in props.song ? props.song.radio : null;
    const { play } = usePlayOrStop("radio" in props.song ? props.song.radio :  null);
    const [showPlay, setShowPlay] = useState(false);
    const content = <>
        <LogoBox showPlay={showPlay} src={image || "https://cdb.radia.cz/design/img/thumbnails/no-artwork-image(image400).png"} alt={`${interpret}, ${song}`} />
        <div className="align-self-start mt-12px">
            <div><strong>{interpret}</strong></div>
            <div className={SongCss.black}>{song}</div>
            {radio ? <div>{radio.name}</div> : null }
        </div>
    </>

    if (radio) {
        return <RouteLink onMouseEnter={()=>{
            setShowPlay(true)
        }} onMouseLeave={()=>{
            setShowPlay(false);
        }} onClick={e=>{
            play();
        }} className={`d-flex ${SongCss.LinkBox} flex-column ${props.className ?? ""}`} to={routes.radio_playlist(radio.slug, {}, "playlist")}>
            {content}
        </RouteLink>
    }

    return (
        <div className={`d-flex ${SongCss.LinkBox} flex-column ${props.className ?? ""}`}>
            {content}
        </div>
    );
}